import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getOrders } from "../../api/apiOrders";

export const useGetOrders = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["orders", params, i18next.language],
        queryFn: () => getOrders(params),
        keepPreviousData: true,
    });

    const orders = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params?.per_page || 15, total: 0 };

    return { isLoading, error, orders, meta, refetch };
};
